<template>
  <span>
    <label v-if="label">{{ label }}</label>
    <div
      class="input-wrapper"
      @mousemove="handleMouseMove"
      @mouseenter="visible = true"
      @mouseleave="visible = false"
      :style="backgroundStyle"
    >
      <input
        v-bind="$attrs"
        :type="type"
        class="custom-input"
        ref="input"
        :value="value"
        @input="$emit('input', $event.target.value)"
        autocomplete="off"
      />
    </div>
  </span>
</template>

<script>
export default {
  name: "Input",
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      mouseX: 0,
      mouseY: 0,
      radius: 80,
    };
  },
  computed: {
    backgroundStyle() {
      const radiusPx = this.visible ? this.radius + "px" : "0px";
      return {
        background: `radial-gradient(circle ${radiusPx} at ${this.mouseX}px ${this.mouseY}px, #84cc16, transparent)`,
        transition: "background 0.3s ease",
      }
    },
  },
  methods: {
    handleMouseMove(e) {
      const rect = e.currentTarget.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  display: block;
  width: 100%;
  margin-bottom: 20px;

  label{
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .input-wrapper {
    padding: 2px;
    border-radius: 8px;
    transition: background 0.3s ease;

    .custom-input {
      width: 100%;
      height: 40px;
      border: none;
      background-color: $backgroundInput;
      color: $corBranco;
      border-radius: 6px;
      padding: 0 12px;
      font-size: 14px;
      outline: none;
      box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.25);
      transition: box-shadow 0.3s ease;
      box-sizing: border-box;
    
      &::placeholder {
        color: #a3a3a3;
      }
    
      &:hover {
        box-shadow: none;
      }
    
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>
